import { render, staticRenderFns } from "./DelCategory.vue?vue&type=template&id=659a33fd&"
import script from "./DelCategory.vue?vue&type=script&lang=js&"
export * from "./DelCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports